import React from 'react';
import UserSmile from "./UserSmile";
import UserStatus from "./UserStatus";

interface PartnerStatusProps {
    online: boolean;
    setEmojiSheet: React.Dispatch<React.SetStateAction<boolean>>;
    userEmojiId: number,
}
const Header:React.FC<PartnerStatusProps> = ({online,setEmojiSheet,userEmojiId}) => {
    return (
        <div className="header flex-row-box glass-effect" style={{justifyContent: 'center', alignItems: 'center'}}>
            <UserSmile guestEmojiId={userEmojiId} setEmojiSheet={setEmojiSheet}/>
            <UserStatus online={online}/>
        </div>
    )
};

export default Header;
